"use client";

import { MediaProgressBar } from "@ui/components/core/MediaProgressBar";
import { useCallback, useRef, useState } from "react";
import {
  BoxedAspectRatioVideo,
  BoxedAspectRatioVideoProps,
} from "@ui/components/core/BoxedAspectRatioVideo/BoxedAspectRatioVideo";
import { Subtitles } from "@utilities/subtitles/subtitleTypes";

export interface BoxedAspectRatioVideoPlayerProps {
  className?: string;
  src: string;
  subtitles?: Subtitles;
  boxAspectRatio?: BoxedAspectRatioVideoProps["boxAspectRatio"];
}

export function BoxedAspectRatioVideoPlayer({
  src,
  className = "",
  subtitles,
  boxAspectRatio,
}: BoxedAspectRatioVideoPlayerProps) {
  const mediaRef = useRef<HTMLVideoElement | null>(null);
  const [isMuted, setIsMuted] = useState(true);

  const handleVideoRef = useCallback((ref: HTMLVideoElement | null) => {
    mediaRef.current = ref;
  }, []);

  const handleMuteToggle = useCallback(() => {
    setIsMuted(prev => !prev);
  }, []);

  const handleMediaClick = useCallback(() => {
    if (!mediaRef.current) return;

    if (mediaRef.current.paused) {
      mediaRef.current.play();
    } else {
      mediaRef.current.pause();
    }
  }, []);

  return (
    <div className={`${className}`}>
      <BoxedAspectRatioVideo
        src={src}
        isMuted={isMuted}
        onMuteToggle={handleMuteToggle}
        onVideoRef={handleVideoRef}
        onVideoClick={handleMediaClick}
        autoPlay={true}
        subtitles={subtitles}
        boxAspectRatio={boxAspectRatio}
      >
        {/* Progress Bar Overlay */}
        <div className='tw-absolute tw-bottom-8 tw-left-4 tw-right-4'>
          <MediaProgressBar mediaRef={mediaRef} size='lg' inverse />
        </div>
      </BoxedAspectRatioVideo>
    </div>
  );
}
